import { LaptopSystemsPanel } from "@/components/admin/LaptopSystemsPanel";

export function SettingsLaptopSystemsPage() {
  return <LaptopSystemsPanel />;
}
